'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getPudoMethodName = pudoOption => {
  if (!pudoOption) return '';
  const {
    pudoActionType,
    pudoActionTypeDetails,
    pudoProvider
  } = pudoOption;
  if (pudoActionType === 'DROP_OFF') {
    if (pudoActionTypeDetails === 'LABEL') {
      if ((pudoProvider === null || pudoProvider === void 0 ? void 0 : pudoProvider.type) === 'CARRIER') return 'mail';
      if ((pudoProvider === null || pudoProvider === void 0 ? void 0 : pudoProvider.type) === 'CONCIERGE') return 'concierge';
      if ((pudoProvider === null || pudoProvider === void 0 ? void 0 : pudoProvider.type) === 'STORE') return 'store';
      return 'self';
    }
    if (pudoActionTypeDetails === 'PRINTERLESS') return 'printerless_mail';
    if (pudoActionTypeDetails === 'BOXLESS') return 'boxless';
  } else if (pudoActionType === 'PICK_UP') {
    if ((pudoProvider === null || pudoProvider === void 0 ? void 0 : pudoProvider.type) === 'COURIER') return 'pickup';
  }
  return '';
};
const generatePudoId = pudoOption => {
  if (!pudoOption) return '';
  const {
    pudoActionType,
    pudoActionTypeDetails,
    pudoProvider,
    serviceType
  } = pudoOption;
  return [pudoActionType, pudoActionTypeDetails, pudoProvider === null || pudoProvider === void 0 ? void 0 : pudoProvider.type, pudoProvider === null || pudoProvider === void 0 ? void 0 : pudoProvider.moniker, serviceType].join('-');
};

exports.generatePudoId = generatePudoId;
exports.getPudoMethodName = getPudoMethodName;
